























import { Component, Prop, Vue } from "vue-property-decorator";
import VModal from "./VModal.vue";

@Component({
  components: {
    VModal,
  },
})
export default class DialogModal extends Vue {
  @Prop({ default: "Messaggio" }) readonly title?: string;

  modal!: VModal;
  content = "";

  confirmed!: Function | null;

  mounted() {
    this.modal = this.$refs.modal as VModal;
  }

  get hasContent(): boolean {
    return this.$slots.default != null;
  }

  protected onConfirm() {
    if (this.confirmed) {
      this.confirmed();
    }

    this.confirmed = null;
    this.modal.hide();
  }

  protected onHidden() {
    if (this.confirmed) {
      this.confirmed();
    }
  }

  dialog(content: string | undefined = undefined): Promise<boolean> {
    this.modal.show();

    if (content) {
      this.content = content;
    }

    return new Promise((resolve) => {
      this.confirmed = () => {
        resolve(true);
      };
    });
  }
}
